import styled from 'styled-components';

export const UserWrapper = styled.div`
  background: ${props => props.backgroundColor};
  font-size: 0.9em;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 5px;
  border-radius: 2px
`;

export const UserName = styled.span`
  margin-right: 10px;
  display: inline-block;
  line-height: 20px;
  vertical-align: middle;
`;